<template>
  <component class="redirect-url-form" :is="redirectUrlData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="redirectUrlData === undefined">
      <h4 class="alert-heading">獲取項目數據時出錯</h4>
    </b-alert>

    <redirect-url-edit-tab-information
      v-if="redirectUrlData"
      :redirect-url-data="redirectUrlData"
      :loading="loading"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onMounted } from "@vue/composition-api";
import store from "@/store";
import RedirectUrlEditTabInformation from "./redirectUrlEditTabInformation.vue";

export default {
  components: {
    RedirectUrlEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const redirectUrlData = ref({id: 2, value: '', contents: [{id: 0, icon: 'fa-diamond-turn-right', url: ''}]});
    const loading = ref(false);

    const refetchData = () => {
      loading.value = true;
        store
          .dispatch("app/fetchSettingInfo", 2)
          .then((response) => {
            redirectUrlData.value = response.data.setting;
            redirectUrlData.value.contents = JSON.parse(response.data.setting.value);
            if (!redirectUrlData.value.contents) {
              redirectUrlData.value.contents = [{id: 0, icon: 'fa-diamond-turn-right', url: ''}]
            }
            loading.value = false
          })
          .catch((error) => {
            console.log("error when fetching redirectUrl", error);
            if (error.response.status === 404) {
              redirectUrlData.value = undefined;
            }
            loading.value = false
          });
    };


    onMounted(() => {
      refetchData();
    });

    return {
      refetchData,
      redirectUrlData,
      loading,
    };
  },
};
</script>

<style lang="scss">

.redirect-url-form {
  max-width: 1200px;
  margin: 0 auto;
}
</style>